import {createTheme} from '@mui/material/styles';

const theme = createTheme({

  typography: {
    fontFamily: 'sans-serif'
  },

  palette: {
    background: {
      default: '#001142'
    }
  }
});

export default theme;
